import { Route } from "vue-router";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Icon, Row, Col, Button } from "ant-design-vue";
import { fmtMsg, GLUtil, ActionItem } from "commonui";
import { LessonPlanLocale, CommonLocale } from "@/locales/localeid";
import { Paths } from "@/util/paths";
import { LessonPlanTemplateActionStatus } from "@/util/enum";
import LessonPlanTemplateState from "@/modules/lesson-plan-template";
import PageTitle from "@/components/page-title/page-title.vue";
import TemplateEditorContent from "./components/editor/editor-content.vue";
import TemplateEditorContentType from "./components/editor/editor-content";

@Component({
	components: {
		"a-row": Row,
		"a-col": Col,
		"a-button": Button,
		Icon,
		ActionItem,
		PageTitle,
		TemplateEditorContent
	}
})
export default class TemplateEditor extends Vue {
	private lessonPlanTemplateModule = getModule(LessonPlanTemplateState);
	public disableSave = true;

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	onChangeDisableSave(value) {
		this.disableSave = value;
	}

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	get commonLocale(): any {
		return CommonLocale;
	}

	get loading(): boolean {
		return this.lessonPlanTemplateModule.loading;
	}

	get lessonPlanTemplateEditorTitle(): string {
		switch (this.lessonPlanTemplateModule.currentLessonPlanTemplateAction) {
			case LessonPlanTemplateActionStatus.Edit:
				return fmtMsg(LessonPlanLocale.LessonPlanTemplateEditFormTitle);
			case LessonPlanTemplateActionStatus.Add:
			default:
				return fmtMsg(LessonPlanLocale.LessonPlanTemplateAddFormTitle);
		}
	}

	get lessonPlanTemplate(): any {
		return this.lessonPlanTemplateModule.currentLessonPlanTemplate;
	}

	beforeRouteLeave(to: Route, from: Route, next: Function) {
		(this.$refs.templateEditorContent as TemplateEditorContentType).onResetFormFieldsValue();
		next();
	}

	onClose(): void {
		this.$router.push(Paths.LessonPlanTemplate);
	}

	onSaveLessonPlanTemplate(): void {
		const success: (values: any) => Promise<void> = async (values) => {
			Object.keys(values).forEach((valueKey) => {
				this.lessonPlanTemplateModule.currentLessonPlanTemplate[valueKey] = values[valueKey];
			});
			const result: boolean = await this.lessonPlanTemplateModule.saveLessonPlanTemplateData(
				this.lessonPlanTemplateModule.currentLessonPlanTemplateAction
			);
			if (result) {
				this.onClose();
			}
		};
		const error: (errors: any, values: any) => void = (errors, values) => {
			// console.log(errors, values);
		};
		(this.$refs.templateEditorContent as TemplateEditorContentType).onSubmitEditorForm(success, error);
	}
}
